import React from 'react';
import { Wrapper } from './index.styles';
import ViewIdDetails from './components/view';
import IdDetailsSkeleton from './skeleton';
import {IEKYCDetails, TUsersDetail} from "../../../../../../types/entities/users";

interface PersonalInfoProps {
  ekycDetails: IEKYCDetails
  userData?: TUsersDetail
}

/*
  Submitted KTP
*/
const IdDetails = ({ ekycDetails, userData }: PersonalInfoProps) => {
  const isLoading = false;
  const isError = false;

  if (isLoading) return <IdDetailsSkeleton />;

  if (isError) return <>{'error'}</>;

  return (
    <Wrapper>
      <ViewIdDetails
        data={ekycDetails}
        userData={userData}
      />
    </Wrapper>
  );
};

export default IdDetails;
